import { posts, ticker } from '@/mocks/entertainment';

const quick = posts.slice(0, 4);

export default function Hero() {
  const feature = posts[3]; // 温以宁封面大图
  return (
    <section id="home-top" className="pt-[120px] md:pt-[128px] pb-0">
      {/* breaking ticker */}
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-stretch overflow-hidden rounded-2xl border border-background-200/80 bg-background-50">
          <div className="flex items-center gap-1.5 px-4 bg-primary-500 text-background-50 text-sm font-bold shrink-0">
            <i className="ri-radar-line animate-ping"></i>
            滚动
          </div>
          <div className="relative flex-1 overflow-hidden bg-primary-50/60">
            <div className="flex items-center whitespace-nowrap marquee-track" style={{ animationDuration: '34s' }}>
              {[...ticker, ...ticker].map((t, i) => (
                <span key={i} className="inline-flex items-center gap-3 px-6 text-sm text-foreground-800">
                  <i className="ri-flashlight-fill text-primary-500 text-xs"></i>
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* hero grid */}
      <div className="mx-auto max-w-7xl px-4 md:px-6 pt-8 grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* big feature */}
        <article className="lg:col-span-2 relative rounded-3xl overflow-hidden group min-h-[360px] md:min-h-[480px]">
          <img
            src={feature.image}
            alt={feature.title}
            className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/25 to-foreground-950/10"></div>
          <div className="absolute inset-x-0 bottom-0 p-5 md:p-8">
            <div className="flex items-center gap-2 mb-3 flex-wrap">
              <span className="px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-bold">置顶 · {feature.badge}</span>
              <span className="px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-800 text-xs">{feature.catName}</span>
            </div>
            <h2 className="text-2xl md:text-4xl font-black text-background-50 leading-snug max-w-2xl">
              {feature.title}
            </h2>
            <p className="mt-3 text-sm md:text-base text-background-100/90 max-w-xl hidden sm:block">{feature.summary}</p>
            <div className="mt-4 flex items-center gap-4 text-xs text-background-200">
              <span className="flex items-center gap-1"><i className="ri-time-line"></i>{feature.minutes} 分钟前</span>
              <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{feature.views} 阅读</span>
              <span className="hidden md:flex items-center gap-1"><i className="ri-verified-badge-line"></i>已核实来源</span>
            </div>
          </div>
        </article>

        {/* right latest quick */}
        <aside className="flex flex-col gap-4">
          <div className="flex items-center justify-between">
            <h3 className="font-heading text-lg font-black text-foreground-950 flex items-center gap-2">
              <span className="w-1.5 h-4 rounded-full bg-accent-500"></span>刚刚 · 实时速览
            </h3>
            <a href="#realtime" className="text-xs text-primary-600 hover:underline whitespace-nowrap flex items-center gap-1">
              全部 <i className="ri-arrow-right-line"></i>
            </a>
          </div>
          <div className="flex flex-col flex-1 overflow-hidden rounded-2xl border border-background-200/70 bg-background-100/50 divide-y divide-background-200/60">
            {quick.map((p, i) => (
              <a key={p.id} href="#realtime" className="group flex items-start gap-3 p-4 hover:bg-background-50 transition">
                <span className={`mt-0.5 w-6 h-6 shrink-0 rounded-md text-xs font-bold flex items-center justify-center ${
                  i === 0 ? 'bg-primary-500 text-background-50' : 'bg-accent-100 text-accent-800'
                }`}>{i + 1}</span>
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-foreground-900 leading-snug group-hover:text-primary-600 line-clamp-2">{p.title}</p>
                  <p className="mt-1 text-xs text-foreground-500 flex items-center gap-2">
                    <span>{p.minutes}分钟前</span>
                    <span className="w-1 h-1 rounded-full bg-background-300"></span>
                    <span>{p.views} 阅读</span>
                  </p>
                </div>
              </a>
            ))}
          </div>
        </aside>
      </div>
    </section>
  );
}